module.exports = __webpack_public_path__ + "img/logo-bule.71e0def6.png";